import { useGraphQLMutation } from '@betterment/graphql';
import { useNavigate } from 'react-router-dom';

import { useCustomFundLineup } from '../../../contexts/CustomFundLineupContext';
import { UpdateQdiaFundLineupDocument } from '../graphql/mutation.updateQdiaFundLineup.generated';

import type { CsvRowError } from '../../../contexts/CustomFundLineupContext';

export const useUpdateQdiaFundLineup = () => {
  const { solo401kPlanId, setRowErrors } = useCustomFundLineup();
  const navigate = useNavigate();
  const [mutate, { loading }] = useGraphQLMutation(UpdateQdiaFundLineupDocument);

  const submit = async (file: File) => {
    const csvContent = await file.text();
    const response = await mutate({
      variables: { input: { solo401kPlanId, csvContent } },
    });

    const { displayableErrors, result } = response.data?.updateQdiaFundLineup ?? {};

    if (displayableErrors && displayableErrors.length > 0) {
      const csvErrors: CsvRowError[] = displayableErrors.map(error => ({
        row: error.path[1] ?? '',
        columnName: error.path[2] ?? '',
        message: error.message,
      }));
      setRowErrors(csvErrors);
      void navigate('../edit', { replace: true });
      return;
    }

    if (result) {
      void navigate('../validated', { replace: true });
    }
  };

  return { submit, loading };
};
